/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit, QueryList, ViewChild, ViewChildren
} from '@angular/core';

import { Logger                } from '@/util/logger';
import { MatSidenav }            from "@angular/material/sidenav";
import {first}                   from "rxjs/operators";
import { SortEvent }             from 'primeng/api';
import {Inplace, InplaceContent} from "primeng/inplace";
import {IOrganizationRow}        from "@/screens/administration/i.organization.row";
import {OrganizationService}     from "@/services/organization.service";
import {fromMySQLDate} from "@/util/util";

@Component({
  standalone: false,
  templateUrl: 'organizations.list.component.html'
})

/**
 *
 * @class OrganizationsListComponent
 *
 * @brief organization management page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class OrganizationsListComponent implements OnInit {

  @ViewChild('adminsidenav')
  public nav: MatSidenav;

  /** the list of CSV style entries for each organization in the system */
  public organizations: IOrganizationRow[] = [];

  /** the organization key to use for creation */
  public orgCreateKey: string = '';

  /** the organization name to use for creation */
  public orgCreateName: string = '';

  /** is the current key/organization name valid for creating an org? */
  public orgInputValid: boolean = false;

  /** standard constructor */
  constructor(
    private orgservice: OrganizationService,
    private cdRef:  ChangeDetectorRef
  ) {


  }

  refresh() {

    let ol: OrganizationsListComponent = this;

    Logger.debug(`[OrganizationsListComponent] looking for organization...`);

    ol.orgservice.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          ol.organizations = [];

          if (data.result) {

            data = data.result;
          }

          data.organizations.forEach((item) => {

            item.created_at = fromMySQLDate(item.created_at).toLocaleString().slice(0, 19).replace(',', '');
            item.updated_at = fromMySQLDate(item.updated_at).toLocaleString().slice(0, 19).replace(',', '');

            ol.organizations.push(item);

          });

          ol.cdRef.detectChanges();

          Logger.debug(`[OrganizationsListComponent] organization: `, ol.organizations);

        },

        error: (error: any): void => {

          Logger.error(`[OrganizationsListComponent] could not fetch organization details: `, error);

        }

      });
  }

  /** on page setup */
  ngOnInit(): void {

    let ol: OrganizationsListComponent = this;

    Logger.debug('[OrganizationsListComponent] init...');

    ol.refresh();

  }

  /** check the "key" input for creating an organization */
  checkKey(event = null): boolean {

    let ol: OrganizationsListComponent = this;

    let name: string = $(`#createorganization`).val().toString().trim();
    let key: string = $(`#createorganizationkey`).val().toString();

    /* clear the current error */

    ol.orgInputValid = true;

    $(`.orgcreateerror`).html('');

    /* any validation issues? */

    if (!/^[a-zA-Z][_a-zA-Z0-9]+$/.test(key)) {

      $(`.orgcreateerror`).html('Organization key must be of pattern [a-zA-Z][_a-zA-Z0-9]+');

      ol.orgInputValid = false;

      ol.cdRef.detectChanges();

      return false;
    }

    if (!name) {

      $(`.orgcreateerror`).html('Organization name can not be empty.');

      ol.orgInputValid = false;

      ol.cdRef.detectChanges();

      return false;
    }

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key == 'Enter') {

        ol.createOrganization(true);
      }

    }

    /* clear to proceed! */

    ol.cdRef.detectChanges();

    return true;
  }

  createOrganization(noCheck: boolean = false) {

    let ol: OrganizationsListComponent = this;
    let name: string = $(`#createorganization`).val().toString();
    let key: string = $(`#createorganizationkey`).val().toString();

    if (!noCheck) {

      /* we haven't checked the values yet */

      if (!ol.checkKey()) {

        /* validation errors */

        return;
      }
    }

    $(`#createorganization`).val('');
    $(`#createorganizationkey`).val('');
    ol.orgInputValid = false;

    Logger.debug(`[OrganizationsListComponent] creating new organization: '${name}', '${key}'...`);

    ol.orgservice.create({name, key})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[OrganizationsListComponent] organization created, refreshing...`);

          ol.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[OrganizationsListComponent] could not create organization: `, error);
        }

      });

  }

  /** set a new name for the given organization */
  saveOrgName(id: number, name: string) {

    let ol: OrganizationsListComponent = this;

    let org: IOrganizationRow = ol.organizations.find(x => x.id == id);

    if (!org) {

      return ;
    }

    /* update locally */

    org.name = name;

    /* update the database... */

    ol.orgservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          /* refresh the list ... */

          ol.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[OrganizationsListComponent] could not save new organization name: `, error);

        }

      });

  }

  orgEditKey(event, id: number, component: Inplace) {

    let ol: OrganizationsListComponent = this;
    let value: string = $(`.orgclass-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[OrganizationsListComponent] org editor RETURN (${id}) => '${value}': `, event);

    ol.saveOrgName(id, value);

  }

  orgEditDeactivate(id: number, component: Inplace) {

    let ol: OrganizationsListComponent = this;
    let value: string = $(`.orgclass-${id} input`).val().toString();

    Logger.debug(`[OrganizationsListComponent] deactivating org editor (${id}) => '${value}': `, component);

    ol.saveOrgName(id, value);

  }

  orgEditActivate(id: number, component: Inplace) {

    let ol: OrganizationsListComponent = this;

    Logger.debug(`[OrganizationsListComponent] activating org editor (${id}): `, component);




  }

  /** check if an organization is deletable */
  canDelete(id: number|string) {

    let ol: OrganizationsListComponent = this;
    let org: IOrganizationRow          = ol.organizations.find(x => x.id == id);

    if (!org) {

      return false;
    }

    let usage: number = org.users.length + org.projects.length;

    if (usage == 0) {

      return true;
    }

    /* still in use somewhere */

    return false;
  }

  /** soft delete a organization */
  deleteOrganization(id: number|string) {

    let ol: OrganizationsListComponent = this;

    Logger.debug(`[OrganizationsListComponent] deleting: ${id} ...`);

    ol.orgservice.deleteOrganization(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: IOrganizationRow = data;

          let org: IOrganizationRow = ol.organizations.find(x => x.id == row.id);

          org.is_deleted = true;

          ol.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationsListComponent] could not delete organization: `, error);

        }

      });
  }

  /** undelete a organization */
  unDeleteOrganization(id: number|string) {

    let ol: OrganizationsListComponent = this;

    Logger.debug(`[OrganizationsListComponent] activating: ${id} ...`);

    ol.orgservice.undeleteOrganization(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: IOrganizationRow = data;

          let org: IOrganizationRow = ol.organizations.find(x => x.id == row.id);

          org.is_deleted = false;

          ol.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[OrganizationsListComponent] could not delete organization: `, error);

        }

      });

  }

  /** expand/collapse the sidebar navigation panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** helper to sort special rows like disk usage */
  tableSort(event: SortEvent) {

    let ol: OrganizationsListComponent = this;

    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];

      /* deal with missing data */

      if (value1 == null && value2 != null) {

        return -1;

      } else if (value1 != null && value2 == null) {

        return 1;

      } else if (value1 == null && value2 == null) {

        return 0;
      }

      if (['id'].includes(event.field)) {

        /* straight number compare */

        return (parseFloat(value2) - parseFloat(value1)) * event.order;
      }

      if (['name', 'key'].includes(event.field)) {

        /* straight string compare */

        return (value1.toString().localeCompare(value2.toString())) * event.order;
      }

      if (event.field == 'created_at') {

        /* date compare */

        /* in some browsers the date format may not be 2025-01-05 11:30:10, it may be 01/05/2025 11:30:10 */

        if (/\//.test(value1)) {

          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[2], t1[0] - 1, t1[1], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :/]/);
          const d2 = new Date(Date.UTC(t2[2], t2[0] - 1, t2[1], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;

        } else {


          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[0], t1[1] - 1, t1[2], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :]/);
          const d2 = new Date(Date.UTC(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;
        }
      }

      /* can not interpret */

      return 0;
    });

    ol.cdRef.detectChanges();
  }

}
